import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useForm, Controller, ErrorMessage } from 'react-hook-form';
import ErrorWrapper from '@components/BaseComponents/ErrorWrapper';
import Form from 'deltoid/core/Form';

import {
  panDetailsActions, panDetailsSelectors,
  masterDataSelectors,
  dialogActions
} from '@store/ducks';

const Confirmation = ({
  panDetails,
  businessEntities,
  closeDialog,
  submitPan,
  submitProcessing,
}) => {
  const { panName, panCardNumber } = panDetails;
  const { pan_business_entity_mapping } = businessEntities;

  const { control, errors, handleSubmit } = useForm();

  const onSubmit = formData => submitPan(formData.businessEntitiy.value);

  return (
    <form className='p-3' onSubmit={handleSubmit(onSubmit)} key='pan-confirmation' data-testid='pan-confirmation-form'>
      <div className="buiness-image">
        <img src='/assets/images/business-user.svg' />
      </div>
      <div className="top-title-wrap">
        <h2>Hello, <span className='d-inline-block'>{panName}</span></h2>
      </div>
      <Form.Group>
        <Form.Label htmlFor='businessEntitiy'>
          Choose your business entity
        </Form.Label>
        <Controller
          as={Form.Select}
          options={panCardNumber ? pan_business_entity_mapping[panCardNumber[3].toUpperCase()]?.map(
            entity => ({ label: entity, value: entity })) : []
          }
          name='businessEntitiy'
          inputId="businessEntitiy"
          control={control}
          placeholder={'Select Business Entity'}
          isSearchable={false}
          rules={{
            required: 'Can not be empty'
          }}
        />
        <ErrorWrapper errors={errors} fieldName='businessEntitiy' data-testid='business-entity-error'/>
      </Form.Group>
      <Form.Button className="default-btn w-100 mt-3" onClick={handleSubmit(onSubmit)} disabled={submitProcessing} loading={submitProcessing}>
        Confirm I am <strong className='d-inline-block'>{panName}</strong>
      </Form.Button>
      <div className="center-wrap-text">
        <Form.Button onClick={closeDialog} variant='underlined' type="button">
          Wrong name? Re-enter PAN
        </Form.Button>
      </div>
      <p className='text-center'>We will compare the name on your PAN with the name on this bank account as per RBI regulation.</p> 
  </form>
  )
};

const mapStateToProps = state => ({
  panDetails: panDetailsSelectors.verifiedPanDetails(state),
  submitProcessing: panDetailsSelectors.submitProcessing(state),
  businessEntities: masterDataSelectors.businessEntities(state)
});

const mapDispatchToProps = dispatch => ({
  closeDialog: () => dispatch(dialogActions.close()),
  submitPan: businessEntity => dispatch(panDetailsActions.submitPan(businessEntity)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);
